export default "__VITE_ASSET__uD6ABymA__"